const validate = (values: any) => {
  const errors: any = {};
  
  if (values.password !== values.confirmPassword) {
    errors.confirmPassword = 'Пароль и подтверждение пароля не совпадают';
  }
  
  return errors;
};

export default validate;
